'use strict';

goog.provide("Ntry.ItemSystem");

goog.require("Ntry.STATIC");

Ntry.ItemSystem = function() {
    Ntry.addEventListener("run", this, this.raiseItem);
    Ntry.addEventListener("stop", this, this.resetItem);
    this._eatenSequencialItemCount = 0;
};

(function(p){
    p.update = function(frameCount) {
        if (!this._unit)
            this.findUnit();
        else if (!Ntry.entityManager.hasComponent(this._unit.id, Ntry.STATIC.UNIT))
            this.findUnit();
        if (!this._unit)
            return;

        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);
        var unitPosition = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.POSITION);
        var unitGrid = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.GRID);
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM);
            if (itemComp.isEaten)
                continue;

            var itemPosition = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.POSITION);
            var itemGrid = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.GRID);

            if (itemPosition.y - itemComp.tolerance < unitPosition.y &&
                itemPosition.y + itemComp.tolerance > unitPosition.y &&
                itemPosition.x - itemComp.tolerance < unitPosition.x &&
                itemPosition.x + itemComp.tolerance > unitPosition.x &&
                itemGrid.x == unitGrid.x && itemGrid.y == unitGrid.y) {
                if (!isNaN(itemComp.sequence)) {
                    if (this._eatenSequencialItemCount != itemComp.sequence)
                        Ntry.dispatchEvent("unitAction", Ntry.STATIC.SEQUENCE_SIMOOROOK);
                    else
                        this._eatenSequencialItemCount++;
                }
                itemComp.isEaten = true;
                Ntry.dispatchEvent("itemFire", itemComp.itemType);
                if (Ntry.STATIC.CONSUMABLE_ITEMS.indexOf(itemComp.itemType) > -1) {
                    Ntry.entityManager.addComponent(
                        id, {
                            type: Ntry.STATIC.ANIMATE,
                            animateType: Ntry.STATIC.FADE_OUT,
                            duration: 0.5
                        }
                    );
                }
            }

            var spriteComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.SPRITE);

            if (spriteComp)
                if (frameCount % 8 == 0)
                    spriteComp.currentFrame = 0;
                else if (frameCount % 8 == 4)
                    spriteComp.currentFrame = 1;
        };
    };

    p.raiseItem = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM
            );
            Ntry.dispatchEvent("raiseItem", itemComp.itemType);
        }
    };

    p.resetItem = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ITEM);
        for (var id in entities) {
            var itemComp = Ntry.entityManager.getComponent(
                id, Ntry.STATIC.ITEM
            );
            itemComp.isEaten = false;
        }
        this._eatenSequencialItemCount = 0;
    };

    p.findUnit = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.UNIT);

        for (var key in entities)
            this._unit = entities[key];
    };
})(Ntry.ItemSystem.prototype);
